import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import LoadListListItemLinkDetails from "./LoadListListItemLinkDetails";

export default function LoadListMapListBody( props ) {

    const serNum = props.data.reelSerialNumber==null?'':props.data.reelSerialNumber;
    const projectName = props.data.projectIdGuid != null && props.data.projectIdGuid != '00000000-0000-0000-0000-000000000000'?props.data.projectName:'No Project';
    const remains = Math.floor(props.data.amt - props.data.curPullSum);
    const daysOld = props.data.shipDateDays;

    return(
        <Paper elevation={3} sx={{p:1, mb:1}}>
                <Box>
                    <Box>
                        {props.data.trackerESN != null
                        ?
                        <Box>
                            {props.data.deferralDaysLeft<30
                                ?
                                    <Typography className="rtsTrackerMarkerRed">{props.data.childIdx}</Typography>
                                :
                                    props.data.deferralDaysLeft<60
                                    ?
                                        <Typography className="rtsTrackerMarkerOrange">{props.data.childIdx}</Typography>
                                    :
                                        props.data.deferralDaysLeft<90
                                        ?
                                            <Typography className="rtsTrackerMarkerGold">{props.data.childIdx}</Typography>
                                        :
                                            <Typography className="rtsTrackerMarkerGreen">{props.data.childIdx}</Typography>
                            }
                        </Box>
                        :
                        <Box>
                            <Typography className="rtsMarker">{props.data.childIdx}</Typography>
                        </Box>
                        }
                        <Box sx={{display:'flex'}}>
                            <Typography variant="h6" sx={{mr:1}}>Reel:</Typography>
                            <Typography variant="h6">{serNum}</Typography>
                        </Box>
                    </Box>
                    <Box sx={{display:'flex'}}>
                        <Typography variant="body2" sx={{fontWeight:'bold', pr:'2px'}}>Product:</Typography>
                        <Typography variant="body2" sx={{textAlign:'left'}}>{props.data.curAliasName + " (" + props.data.curAliasNumber + ")"}</Typography>
                    </Box>
                    <Box sx={{display:'flex'}}>
                        <Typography variant="body2" sx={{fontWeight:'bold', pr:'2px'}}>Remaining:</Typography>
                        <Typography variant="body2">{remains.toLocaleString(undefined, { maximumFractionDigits: 2 })}</Typography>
                    </Box>
                    <Box sx={{display:'flex'}}>
                        <Typography variant="body2" sx={{fontWeight:'bold', pr:'2px'}}>Days Old:</Typography>
                        <Typography variant="body2">{daysOld.toLocaleString()}</Typography>
                    </Box> 
                    <Box sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                        <LoadListListItemLinkDetails idGuid={props.data.idGuid} />
                    </Box>                                       
                </Box>
 
        </Paper>
    );
}
